"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BankIdCancelResponse = void 0;
var zod_1 = require("zod");
var BankIdCancelResponse;
(function (BankIdCancelResponse) {
    BankIdCancelResponse.Schema = zod_1.z.object({});
})(BankIdCancelResponse || (BankIdCancelResponse = {}));
exports.BankIdCancelResponse = BankIdCancelResponse;
